/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Field_ChallengeInputs */

const en_us2_clubs_field_challenge = /** @type {(inputs: Clubs_Field_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Challenge`)
};

const pt_br2_clubs_field_challenge = /** @type {(inputs: Clubs_Field_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desafio`)
};

const es_419_clubs_field_challenge = /** @type {(inputs: Clubs_Field_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desafío`)
};

const pt_pt2_clubs_field_challenge = /** @type {(inputs: Clubs_Field_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desafio`)
};

const fr_fr2_clubs_field_challenge = /** @type {(inputs: Clubs_Field_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Défi`)
};

const de_de2_clubs_field_challenge = /** @type {(inputs: Clubs_Field_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Challenge`)
};

const it_it2_clubs_field_challenge = /** @type {(inputs: Clubs_Field_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sfida`)
};

/**
* | output |
* | --- |
* | "Challenge" |
*
* @param {Clubs_Field_ChallengeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_field_challenge = /** @type {((inputs?: Clubs_Field_ChallengeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Field_ChallengeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_field_challenge(inputs)
	if (locale === "es-419") return es_419_clubs_field_challenge(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_field_challenge(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_field_challenge(inputs)
	if (locale === "de-DE") return de_de2_clubs_field_challenge(inputs)
	if (locale === "it-IT") return it_it2_clubs_field_challenge(inputs)
	return en_us2_clubs_field_challenge(inputs)
});
export { clubs_field_challenge as "clubs.field_challenge" }